<template>
  <number-input :maxlength="maxLength" :placeholder="placeholder" :addonAfter="addonAfter" :disabled="disabled" v-model:value="inputValue"></number-input>
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch, getCurrentInstance } from "vue";
import NumberInput from "../number-input/index.vue"
import {Form} from "ant-design-vue"
export default defineComponent({
  isGlobal: true,
  name: "NumberMoneyInput",
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: [Number,String],
      default: 10,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components:{NumberInput},
  emits: ["update:value", "input","change"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const { proxy } = getCurrentInstance() as any;
    const addonAfter = computed(() => {
      return proxy.$filters.moneyToChinese(inputValue.value);
    });
    const inputValue = ref<string>("");   
    watch(()=>inputValue.value,(n)=>{
      emit("update:value",n);
      emit("change",n);
       formItemContext.onFieldChange();
    })
    watch(
      () => props.value,
      (n) => {
        console.log("🚀 ~ file: index.vue:49 ~ setup ~ n:", n)
        //@ts-ignore
        inputValue.value = n||0;
      }
    );

    return {
      inputValue,
      addonAfter,
    };
  },
});
</script>
<style>
/* to prevent the arrow overflow the popup container,
or the height is not enough when content is empty */
.numeric-input .ant-tooltip-inner {
  min-width: 32px;
  min-height: 37px;
}

.numeric-input .numeric-input-title {
  font-size: 14px;
}
</style>
